// Decide which (slot, step) the picker should focus on next, given the
// current selections and the slot counts. Pose and background slot counts can
// differ (e.g. one pose with two backgrounds, or three poses with one
// background), so each step's bounds are checked independently.
//
// Returns null when nothing is left to configure.
export const pickNextConfigSlot = ({
  posesCount,
  productBackgroundOptionsCount,
  poseSelections,
  backgroundSelections,
  lastFilled = null,
  skipBackgroundSelection = false,
  backgroundOptions = [],
}) => {
  const poseStepAvailable = posesCount > 0;
  const backgroundStepAvailable =
    !skipBackgroundSelection &&
    productBackgroundOptionsCount > 0 &&
    (backgroundOptions?.length ?? 0) > 0;

  if (lastFilled) {
    const { slotIndex, step } = lastFilled;

    if (
      step === 'pose' &&
      backgroundStepAvailable &&
      slotIndex < productBackgroundOptionsCount &&
      !backgroundSelections[slotIndex]
    ) {
      return { slotIndex, step: 'background' };
    }

    if (
      step === 'background' &&
      poseStepAvailable &&
      slotIndex < posesCount &&
      !poseSelections[slotIndex]
    ) {
      return { slotIndex, step: 'pose' };
    }
  }

  if (poseStepAvailable) {
    for (let i = 0; i < posesCount; i++) {
      if (!poseSelections[i]) {
        return { slotIndex: i, step: 'pose' };
      }
    }
  }

  if (backgroundStepAvailable) {
    for (let i = 0; i < productBackgroundOptionsCount; i++) {
      if (!backgroundSelections[i]) {
        return { slotIndex: i, step: 'background' };
      }
    }
  }

  return null;
};
